// extracted by mini-css-extract-plugin
module.exports = {"activities-list":"CollaborationSidebar_activities-list__3XU31","activities-list-item":"CollaborationSidebar_activities-list-item__VtpTj"};